import { api } from "./api";

const fetchIndicatedList = async () => {
  try {
    const { data } = await api.post(
      "/database/indicated_list__c/aggregate",
      []
    );

    const categories = Array.from(
      new Set(data.map((item: any) => item.categoria))
    );

    const grouped = categories.map((category) => {
      const realizations = data.filter(
        (item: any) => item.categoria === category
      );
      return {
        categoryName: category,
        realizations: realizations,
      };
    });
    console.log(grouped);
    return grouped;
  } catch (e) {
    throw e;
  }
};

export { fetchIndicatedList };